import { render, staticRenderFns } from "./FeeUnitSubGroup.vue?vue&type=template&id=38a460f9&"
import script from "./FeeUnitSubGroup.vue?vue&type=script&lang=js&"
export * from "./FeeUnitSubGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports